// extracted by mini-css-extract-plugin
export default {"container":"t3jlKN","button":"lJdXsj","icon":"Cpz9ZU","tooltipInner":"fshQKH","tooltipText":"FGykfY","tooltip":"cpjcVx"};